import { LogsService } from "@gtpl/shared-services/user-logs";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { TeamsEntity } from "./entities/teams.entity";
import { TeamsAdapter } from "./teams.adapter";
import { TeamController } from "./teams.controller";
import { TeamsService } from "./teams.service";

@Module({
    imports: [
      TypeOrmModule.forFeature([TeamsEntity]),
    ],
    controllers: [TeamController],
    providers: [TeamsService, TeamsAdapter, ApplicationExceptionHandler,LogsService],
    exports: [TeamsService]
  })
  export class TeamModule {}